import { render, staticRenderFns } from "./VEditProjectMilestoneForm.vue?vue&type=template&id=86117ce6&"
import script from "./VEditProjectMilestoneForm.vue?vue&type=script&lang=js&"
export * from "./VEditProjectMilestoneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports